/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { identifier } from "stylis";
import checkout from "./form";
import moment from "moment";

const {
  formField: {
    devicePrimary,
    deviceSecondary,
    organisation_id,
    location,
    inspection_type,
    title,
    description,
    maintenance_tag,
    resolved,
    recordedAt,
    priority,
    recordType,
    technician
  },
} = checkout;

const defaultServiceValues = {
  [devicePrimary.uuid.name]: "",
  [devicePrimary.serial_no.name]: "",
  [devicePrimary.stop_id.name]: "",
  // [devicePrimary.description.name]: "",
  [devicePrimary.info.name]: "",
  [devicePrimary.images.name]: [],
  [devicePrimary.conditions.vandalised.name]: false,
  [devicePrimary.conditions.damaged.name]: false,
  [devicePrimary.conditions.audio.name]: false,
  [devicePrimary.conditions.power.name]: false,
  [devicePrimary.conditions.frozen.name]: false,
  [devicePrimary.conditions.location.name]: false,
  [devicePrimary.conditions.other.name]: "",
  [devicePrimary.actions.removed.name]: false,
  [devicePrimary.actions.installed.name]: false,
  [devicePrimary.actions.cleaned.name]: false,
  [devicePrimary.actions.battery_swap.name]: false,
  [devicePrimary.actions.hardware_changed.name]: false,
  [devicePrimary.actions.cosmetically_fixed.name]: false,
  [devicePrimary.actions.other.name]: "",
  [deviceSecondary.uuid.name]: "",
  [deviceSecondary.serial_no.name]: "",
  [deviceSecondary.stop_id.name]: "",
  // [deviceSecondary.description.name]: "",
  [deviceSecondary.info.name]: "",
  [deviceSecondary.images.name]: [],
  [deviceSecondary.conditions.vandalised.name]: false,
  [deviceSecondary.conditions.damaged.name]: false,
  [deviceSecondary.conditions.audio.name]: false,
  [deviceSecondary.conditions.power.name]: false,
  [deviceSecondary.conditions.frozen.name]: false,
  [deviceSecondary.conditions.location.name]: false,
  [deviceSecondary.conditions.other.name]: "",
  [deviceSecondary.actions.removed.name]: false,
  [deviceSecondary.actions.installed.name]: false,
  [deviceSecondary.actions.cleaned.name]: false,
  [deviceSecondary.actions.battery_swap.name]: false,
  [deviceSecondary.actions.hardware_changed.name]: false,
  [deviceSecondary.actions.cosmetically_fixed.name]: false,
  [deviceSecondary.actions.other.name]: "",
  [organisation_id.name]: "", //drop down select
  [location.name]: "",
  [inspection_type.name]: "",
  [title.name]: "", // textbox
  [description.name]: "", // text area
  [maintenance_tag.name]: "",
  [recordedAt.name]: "",
  [priority.name]: "",
  [recordType.name]: false,
  [resolved.name]: false, // toggle checkbox
  // [technician.name]: ""//user.nickname // pre-defined
}

export default defaultServiceValues;
